var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"announcements-button",attrs:{"type":"button","title":"Avisos","aria-label":"Avisos"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('a-badge',{attrs:{"count":_vm.count,"offset":[2, -2]}},[_c('span',{staticClass:"material-icons-outlined announcements-icon"},[_vm._v("campaign")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }